import { render, staticRenderFns } from "./DeviceDetect.vue?vue&type=template&id=01b7df30&scoped=true&"
import script from "./DeviceDetect.vue?vue&type=script&lang=js&"
export * from "./DeviceDetect.vue?vue&type=script&lang=js&"
import style0 from "./DeviceDetect.vue?vue&type=style&index=0&id=01b7df30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b7df30",
  null
  
)

export default component.exports